import { SerializedFarmConfig } from '@pancakeswap/farms'
import { shibariumTokens } from '@pancakeswap/tokens'

const farms: SerializedFarmConfig[] = [
  {
    pid: 2,
    v1pid: 2,
    lpSymbol: 'Chewy-Bone LP',
    lpAddress: '0x324EEf33AF720cE44DEAB7e32F4367a82b4eA43b',
    boosted: false,
    token: shibariumTokens.chewy,
    quoteToken: shibariumTokens.wbone,
  },
].map((p) => ({ ...p, token: p.token.serialize, quoteToken: p.quoteToken.serialize }))

export default farms